import { render } from "./footer.vue?vue&type=template&id=577a744f&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-577a744f"

export default script